import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod/v4";
import { UnclearNextStepsPage } from "../../unclearNextSteps/UnclearNextStepsPage";

const searchSchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
});

export const Route = createFileRoute("/jahresabschluesse/")({
  validateSearch: zodValidator(searchSchema),
  loader: async ({ context: { queryClient, trpc } }) => {
    void queryClient.ensureQueryData(
      trpc.annualStatements.listAnnualStatementsWithUnclearNextSteps.queryOptions(
        {
          limit: 20,
          offset: 0,
        }
      )
    );
  },
  component: JahresabschluesseRoute,
});

function JahresabschluesseRoute() {
  const navigate = useNavigate();
  const { page } = Route.useSearch();

  const setPage = (newPage: number) => {
    navigate({
      to: "/jahresabschluesse",
      search: { page: newPage },
    });
  };

  return <UnclearNextStepsPage page={page} onPageChange={setPage} />;
}
